import { render, staticRenderFns } from "./IngresarPagoEnOVRechazada.vue?vue&type=template&id=0664cc86&lang=pug"
import script from "./IngresarPagoEnOVRechazada.vue?vue&type=script&lang=js"
export * from "./IngresarPagoEnOVRechazada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports